import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Texto de ayuda estándar bajo los campos numéricos que admiten decimales.
 * Se enlaza al campo con `aria-describedby` (`[ariaDescribedBy]="id"` en p-inputNumber).
 * Cuando el campo muestra un error de validación, éste reemplaza a la ayuda.
 */
@Component({
  selector: 'app-decimal-hint',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <small
      [id]="id()"
      class="block mt-1 text-xs text-gray-500 dark:text-gray-400"
    >
      Use coma para los decimales. Ej.: {{ ejemplo() }}
    </small>
  `,
})
export class DecimalHintComponent {
  /** Id único del texto, para `aria-describedby` del campo. */
  readonly id = input.required<string>();
  /** Ejemplo propio del dominio del campo (horas, cantidad, etc.). */
  readonly ejemplo = input<string>('1,5');
}
